<!-- 大宗商化工直发领料数据 -->
<template>
  <h-list-page class="bulk-report-container">
    <h-card title="筛选条件" width="100%" is-search @change-method="changeMethod" footer>
      <h-area title-width="90px">
        <h-search title="单号">
          <h-input v-model.trim="searchData.contractNumber" clearable></h-input>
        </h-search>
        <h-search title="捆包号">
          <h-input v-model.trim="searchData.coilNumber" clearable></h-input>
        </h-search>
        <h-search title="提单号">
          <h-input v-model.trim="searchData.billNo" clearable></h-input>
        </h-search>
        <h-search title="入厂检验结论">
          <h-select v-model="searchData.batchTestConclusion" placeholder="请选择" filterable clearable>
            <h-option v-for="item in batchTestConclusionList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <!-- TODO -->
        <h-search title="现场退次提交状态">
          <h-select v-model="searchData.confirmStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in confirmStatusList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search title="入厂不合格确认状态">
          <h-select v-model="searchData.batchAppealStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in batchAppealList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search title="现场退次确认状态">
          <h-select v-model="searchData.spotAppealStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in spotAppealList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search title="入厂终判状态">
          <h-select v-model="searchData.batchCheckStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in batchCheckList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search title="现场终判状态">
          <h-select v-model="searchData.spotCheckStatus" placeholder="请选择" filterable clearable>
            <h-option v-for="item in spotCheckList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <template #operate>
          <div class="flex-end">
            <h-button type="primary" :loading="tableLoading" @click="handleSearch">
              <template #icon><search /></template>查询
            </h-button>
          </div>
        </template>
      </h-area>
    </h-card>
    <h-table-card title="大宗商钢板报告数据">
      <!-- <template #buttonGroup>
        <h-button-group>
          <div style="margin-left: 10px;">
            <h-button type="primary" @click="handleVersion">
            切换旧版
            </h-button>
            <span style="font-size: 12px;color: red;position: relative;top: 5px;">
              备注：大宗商质量数据新版试运行，老版本预计10月30号下线；新版使用过程中若有问题请及时反馈，紧急业务可优先切换旧版处理。
            </span>
          </div> 
        </h-button-group>
      </template> -->
      <el-table empty-text="暂无数据" v-loading="tableLoading" border :data="tableData"
        size="small" style="width: 100%; min-height: 520px" height="540">
        <el-table-column prop="bulkContractNumber" label="单号" width="160"></el-table-column>
        <el-table-column prop="bulkCoilNumber" label="捆包号" width="120"></el-table-column>
        <el-table-column prop="storageTime" label="入库时间" width="100"></el-table-column>
        <el-table-column prop="parkName" label="园区"></el-table-column>
        <el-table-column prop="bulkSupplyCode" label="大宗商编码"></el-table-column>
        <el-table-column prop="bulkSupplyName" label="大宗商名称" width="220"></el-table-column>
        <el-table-column prop="mtlNo" label="物料号" width="140"></el-table-column>
        <el-table-column prop="mtlName" label="物料名称" width="220"></el-table-column>
        <el-table-column prop="mtlCategoryName" label="物料类别"></el-table-column>
        <el-table-column prop="amount" label="数量"></el-table-column>
        <el-table-column prop="unit" label="单位"></el-table-column>
        <el-table-column prop="checkReportName" label="检验报告" width="180">
          <template v-slot="scope">
            <span title="附件下载" class="blue-text" v-show="scope.row.checkReportUUID"
            @click="downLoadFileFromSQM(scope.row.bulkSupplyCode,scope.row.checkReportUUID,scope.row.checkReportName,scope.row.isSynchro)">查看附件</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractNumber" label="单号" width="160"></el-table-column>
        <el-table-column prop="coilNumber" label="捆包号" width="160"></el-table-column>
        <el-table-column prop="billNo" label="提单号" width="160"></el-table-column>
        <el-table-column prop="supplyCode" label="供应商编码" width="160"></el-table-column>
        <el-table-column prop="supplyName" label="供应商名称" width="160"></el-table-column>
        <el-table-column prop="useAmount" label="领用数量" width="160"></el-table-column>
        <el-table-column prop="unit" label="单位" width="160"></el-table-column>
        <el-table-column prop="useDate" label="领料时间" width="160"></el-table-column>
        <el-table-column prop="batchTestConclusion" label="入厂检验结论" width="160">
          <template v-slot="scope">
            <span v-show="scope.row.batchTestConclusion=='P'">合格</span>
            <span v-show="scope.row.batchTestConclusion=='F'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchCheckReportName" label="入厂检验报告" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.batchCheckReportUUID" @click="handleDownLoad(scope.row.batchCheckReportUUID,scope.row.batchCheckReportName,scope.row.isSynchro)">查看附件</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="uploadDate" label="上传时间" width="160"></el-table-column>
        <el-table-column prop="uploadStatusName" label="上传" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="roleFlag=='S'&&scope.row.supplyCode ==$route.query.supplyCode&&(scope.row.uploadStatus==''||scope.row.uploadStatus==undefined||scope.row.uploadStatus=='N')" 
              @click="handleToReport(scope.row)">上传</span>
            <span v-else>{{ scope.row.uploadStatusName||'待上传' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="batchAppealStatusName" label="入厂不合格确认" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="roleFlag=='S'&&(scope.row.bulkSupplyCode ==$route.query.supplyCode)&&(scope.row.batchAppealStatus=='W')" 
            @click="handleBatchAppeal(scope.row)">操作</span>
            <span v-else>{{ scope.row.batchAppealStatusName||'待确认' }}</span>
          </template> 
        </el-table-column>
        <el-table-column prop="batchAppealFileName" label="入厂确认附件" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.batchAppealFileUUID" @click="handleDownLoad(scope.row.batchAppealFileUUID,scope.row.batchAppealFileName,scope.row.isSynchro)">查看附件</span>
            <span v-else></span>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column prop="batchCheckStatusName" label="入厂终判结论" width="160"></el-table-column>
        <el-table-column prop="batchCheckFileName" label="入厂终判附件" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.batchCheckFileUUID" @click="handleDownLoad(scope.row.batchCheckFileUUID,scope.row.batchCheckFileName,scope.row.isSynchro)">{{ scope.row.batchCheckFileName }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="rejectsReplenishmentNumber" label="退次不合格数量" width="160"></el-table-column>
        <el-table-column prop="rejectsReplenishmentUnit" label="单位" width="160"></el-table-column>
        <el-table-column prop="rejectsReplenishmentFlawMark" label="退次缺陷描述" width="160"></el-table-column>
        <el-table-column prop="backFileName" label="退次附件" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.backFileUUID" @click="handleDownLoad(scope.row.backFileUUID,scope.row.backFileName,scope.row.isSynchro)">查看附件</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="confirmDate" label="录入时间" width="160"></el-table-column>
        <el-table-column prop="confirmStatus" label="提交" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="roleFlag=='S'&&(scope.row.supplyCode ==$route.query.supplyCode)&&(scope.row.confirmStatus=='N')" 
            @click="handleConfirm(scope.row)">提交</span>
            <span v-else>{{ scope.row.confirmStatusName || '待提交'}}</span>
          </template> 
        </el-table-column>
        <el-table-column prop="spotAppealStatusName" label="退次不合格确认" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="roleFlag=='S'&&(scope.row.bulkSupplyCode ==$route.query.supplyCode)&&(scope.row.spotAppealStatus=='W')" 
            @click="handleSpotAppeal(scope.row)">操作</span>
            <span v-else>{{ scope.row.spotAppealStatusName || '待确认'}}</span>
          </template> 
        </el-table-column>
        <el-table-column prop="spotAppealFileName" label="现场确认附件" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.spotAppealFileUUID" @click="handleDownLoad(scope.row.spotAppealFileUUID,scope.row.spotAppealFileName,scope.row.isSynchro)">查看附件</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="spotCheckStatusName" label="现场终判结论" width="160"></el-table-column>
        <el-table-column prop="spotCheckFileName" label="现场终判附件" width="160">
          <template v-slot="scope">
            <span class="blue-text" v-if="scope.row.spotCheckFileUUID" @click="handleDownLoad(scope.row.spotCheckFileUUID,scope.row.spotCheckFileName,scope.row.isSynchro)">{{ scope.row.spotCheckFileName }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="spotCheckCount" label="现场终判数量" width="120"></el-table-column>
      </el-table>
      <el-pagination background @current-change="handlePageChange"
        v-model:currentPage="currentPage" :page-size="10"
        layout="total, prev, pager, next,jumper" :total="total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>

<script>
import { batchAppealList,spotAppealList,batchTestConclusionList, batchCheckList,spotCheckList,confirmStatusList } from '../hmqm/index'

export default {
  data(){
    return{
      searchData:{},
      tableLoading: false,
      tableData:[],
      pageNo:1,
      total:0,
      batchAppealList,
      spotAppealList,
      batchTestConclusionList, 
      batchCheckList,
      spotCheckList,
      confirmStatusList,
      roleFlag:''
    }
  },
  methods:{
    changeMethod() {
      this.postThisPageHeight();
    },
    handleSearch(){
      this.pageNo = 1
      this.getTableData()
    },
    // 获取页面数据
    getTableData(){
      this.tableLoading = true
      this.$http({
        method: "post",
        url: "/base/doubleDistributionMaterial/selectPage",
        headers: { "content-type": "application/json" },
        data: {
          pageNo: this.pageNo,
          pageSize: 10,
          dataFlag:'HZ',// G:钢板 HZ：化工直发 HFZ：化工非直发
          sqmSupplyCode: this.$route.query.supplyCode,
          ...this.searchData
        },
      }).then((res) => {
        console.log('ressss',res)
        if(res.data.code==0){
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total
          console.log('this.total',this.total)
        }
        this.tableLoading = false
      }).catch(err => {
        console.log(err)
      })  
    },
    handlePageChange(val){
      this.pageNo = val
      this.getTableData()
    },
    downLoadFileFromSQM(bulkSupplyCode,uuid,fileName,isSynchro){
      if(uuid == ""||uuid == undefined ||uuid == null){
        this.info("没有可下载的文件！");
        return false;
      }
      let suffix = uuid.includes("mkhl/") || uuid.includes("/testonline/");
  
      //同步的报告按供应商分类查看报告
      if(isSynchro == "Y"){
        if(bulkSupplyCode=="V12973"){
            window.open("https://sqm.haier.net/readFile/testonline/baogang/"+fileName+".pdf","_blank");
        }else{
          if (suffix) {
            let url = uuid.includes("file/mkhl/testonline/") ? "/base/fileDownload/downloadFile?filePath=" + uuid.split('/file/mkhl')[1] : uuid.includes("testonline/baogang") ? "/base/fileDownload/downloadFile?filePath=" + uuid : "/base/fileDownload/downloadFile?filePath=" + uuid;;
            let extension = uuid.substring(uuid.lastIndexOf('.') );
            let downLoadFileName = uuid.includes("file/mkhl/testonline/")||uuid.includes("testonline/baogang") ? `${fileName}${extension}` : fileName
            this.httpFile(
              {
                method: "get",
                url: url,
                headers: { "content-type": "application/json" },
              },
              downLoadFileName
            );
          } else{
            let url = `/base/fileDownload/downLoadFileFtp?type=10&fileUUID=${uuid}`;
            this.httpFile(
              {
                method: "get",
                url: url,
                headers: { "content-type": "application/json" },
              },
              fileName
            );
          }
        }
      }else{
        if (suffix) {
          let url = uuid.includes("file/mkhl/testonline/") ? "/base/fileDownload/downloadFile?filePath=" + uuid.split('/file/mkhl')[1] : uuid.includes("testonline/baogang") ? "/base/fileDownload/downloadFile?filePath=" + uuid : "/base/fileDownload/downloadFile?filePath=" + uuid;;
          let extension = uuid.substring(uuid.lastIndexOf('.') );
          let downLoadFileName = uuid.includes("file/mkhl/testonline/")||uuid.includes("testonline/baogang") ? `${fileName}${extension}` : fileName
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            downLoadFileName
          );
        } else{
          let url = `/base/fileDownload/downLoadFileFtp?type=9&fileUUID=${uuid}`;
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            fileName
          );
        }
      }
    },
    // 上传
    handleToReport(row){
      let params = Object.assign({},{...this.$route.query,...this.searchData})
      params.qualityDataId = row.qualityDataId
      params.coilNumber = row.coilNumber
      params.contractNumber = row.contractNumber
      params.routeName = this.$route.name

      params.roleCode = this.$route.query.roleCode
      params.supplyCode = this.$route.query.supplyCode||this.$route.query.vCode
      if(this.searchData.contractNumber){
        params.searchContractNumber = this.searchData.contractNumber
      }else{
        params.searchContractNumber = ''
      }
      if(this.searchData.coilNumber){
        params.searchCoilNumber = this.searchData.coilNumber
      }else{
        params.searchCoilNumber = ''
      }
      if(this.searchData.billNo){
        params.searchBillNo = this.searchData.billNo
      }else{
        params.searchBillNo = ''
      }
      this.$router.push({name:'uploadQualityReport',query:{...params}})
    },
    // 提交
    handleConfirm(row){
      let params = Object.assign({},{...this.$route.query,...this.searchData})
      params.qualityDataId = row.qualityDataId
      params.coilNumber = row.coilNumber
      params.contractNumber = row.contractNumber
      params.routeName = this.$route.name
      params.supplyCode = this.$route.query.supplyCode||this.$route.query.vCode
      params.roleCode = this.$route.query.roleCode
      if(this.searchData.contractNumber){
        params.searchContractNumber = this.searchData.contractNumber
      }else{
        params.searchContractNumber = ''
      }
      if(this.searchData.coilNumber){
        params.searchCoilNumber = this.searchData.coilNumber
      }else{
        params.searchCoilNumber = ''
      }
      if(this.searchData.billNo){
        params.searchBillNo = this.searchData.billNo
      }else{
        params.searchBillNo = ''
      }
      this.$router.push({name:'uploadQualityReportConfirm',query:{...params}})
    },
    // 入厂不合格确认
    handleBatchAppeal(row){
      let params = Object.assign({},{...this.$route.query,...this.searchData})
      params.qualityDataId = row.qualityDataId
      params.routeName = this.$route.name
      params.roleCode = this.$route.query.roleCode
      params.supplyCode = this.$route.query.supplyCode||this.$route.query.vCode
      if(this.searchData.contractNumber){
        params.searchContractNumber = this.searchData.contractNumber
      }else{
        params.searchContractNumber = ''
      }
      if(this.searchData.coilNumber){
        params.searchCoilNumber = this.searchData.coilNumber
      }else{
        params.searchCoilNumber = ''
      }
      if(this.searchData.billNo){
        params.searchBillNo = this.searchData.billNo
      }else{
        params.searchBillNo = ''
      }
      this.$router.push({name:'batchAppealQuality',query:{...params}})
    },
    handleSpotAppeal(row){
      let params = Object.assign({},{...this.$route.query,...this.searchData})
      params.qualityDataId = row.qualityDataId
      params.coilNumber = row.coilNumber
      params.contractNumber = row.contractNumber
      params.routeName = this.$route.name
      params.supplyCode = this.$route.query.supplyCode||this.$route.query.vCode
      params.roleCode = this.$route.query.roleCode
      if(this.searchData.contractNumber){
        params.searchContractNumber = this.searchData.contractNumber
      }else{
        params.searchContractNumber = ''
      }
      if(this.searchData.coilNumber){
        params.searchCoilNumber = this.searchData.coilNumber
      }else{
        params.searchCoilNumber = ''
      }
      if(this.searchData.billNo){
        params.searchBillNo = this.searchData.billNo
      }else{
        params.searchBillNo = ''
      }
      this.$router.push({name:'spotAppealQuality',query:{...params}})
    },
    handleDownLoad(uuid,fileName){
      if(uuid == ""||uuid == undefined ||uuid == null){
        this.info("没有可下载的文件！");
        return false;
      }
      let suffix = uuid.includes("mkhl/") || uuid.includes("/testonline/");
  
      //同步的报告按供应商分类查看报告
      if(isSynchro == "Y"){
        if(bulkSupplyCode=="V12973"){
            window.open("https://sqm.haier.net/readFile/testonline/baogang/"+fileName+".pdf","_blank");
        }else{
          // window.location.href="/downLoadFileNew?type=10&fileUUID="+uuid;
          let url = `/base/fileDownload/downLoadFileFtp?type=10&fileUUID=${uuid}`;
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            fileName
          );
        }
      }else{
        if (suffix) {
          let url = uuid.includes("file/mkhl/testonline/") ? "/base/fileDownload/downloadFile?filePath=" + uuid.split('/file/mkhl')[1] : uuid.includes("testonline/baogang") ? "/base/fileDownload/downloadFile?filePath=" + uuid : "/base/fileDownload/downloadFile?filePath=/" + uuid;;
          let extension = uuid.substring(uuid.lastIndexOf('.') );
          let downLoadFileName = uuid.includes("file/mkhl/testonline/")||uuid.includes("testonline/baogang") ? `${fileName}${extension}` : fileName
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            downLoadFileName
          );
        } else{
          let url = `/base/fileDownload/downLoadFileFtp?type=9&fileUUID=${uuid}`;
          this.httpFile(
            {
              method: "get",
              url: url,
              headers: { "content-type": "application/json" },
            },
            fileName
          );
        }
      }
    },
    handleVersion(){
      const vCode = this.$route.query.supplyCode
     
      if (process.env.NODE_ENV != 'production') {
        window.open("https://t-api-cn-sp000339-bridge-i.hwork.haier.net/report/bulk_supplier_zf_quality_data_list?supplyCode="+ vCode)
      }else{
        window.open("https://sqm.haier.net/report/bulk_supplier_zf_quality_data_list?supplyCode="+ vCode)
      }
        
    }
  },
  mounted(){
    let vcode =''
    let roleCode = this.$route&&this.$route.query&&this.$route.query.roleCode?this.$route.query.roleCode : ''
    console.log('roleCode1',roleCode)
    if(roleCode&&roleCode.indexOf("H")==0){//如果是海尔端
      vcode = this.$route.query.vCode || this.$route.query.supplyCode
      if(vcode!=""){
        this.roleFlag="SN";
      }
      console.log('this.roleFlag2',this.roleFlag)
    }else{//如果是供应商端。控制只显示本供应商下的样检单
      vcode = this.$route&&this.$route.query&&this.$route.query.supplyCode?this.$route.query.supplyCode:''
      if(roleCode=="S009"){//只有质量经理才能操作
        this.roleFlag="S";
      }else{
        this.roleFlag="SN";
      }
      console.log('this.roleFlag2',this.roleFlag)
    }
    
    if (this.$route.query) {
      this.searchData.name = this.$route.query.name;  
      this.searchData.nickName = this.$route.query.nickName || this.$route.query.name;
      window.getItemName = this.$route.query.name;
      window.getItemNickName = this.$route.query.nickName || this.$route.query.name;
      this.searchData.contractNumber = this.$route.query.searchContractNumber || this.$route.query.contractNumber
      this.searchData.coilNumber = this.$route.query.searchCoilNumber||this.$route.query.coilNumber
      this.searchData.billNo = this.$route.query.searchBillNo || this.$route.query.billNo
      this.searchData.batchTestConclusion = this.$route.query.batchTestConclusion
      this.searchData.confirmStatus = this.$route.query.confirmStatus
      this.searchData.batchAppealStatus = this.$route.query.batchAppealStatus
      this.searchData.spotAppealStatus = this.$route.query.spotAppealStatus
      this.searchData.batchCheckStatus = this.$route.query.batchCheckStatus
      this.searchData.spotCheckStatus = this.$route.query.spotCheckStatus
    }
    this.getTableData()
  }
}
</script>
<style scoped>
.blue-text{
  color: #165dff;
  cursor: pointer;
}
</style>